import { render, staticRenderFns } from "./service_tax.vue?vue&type=template&id=689c44cd&scoped=true&"
import script from "./service_tax.vue?vue&type=script&lang=js&"
export * from "./service_tax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689c44cd",
  null
  
)

export default component.exports